import { Breadcrumbs, BreadcrumbsItem } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { TEST_IDS } from '../../../testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SearchBreadcrumbs = () => {
  const history = useHistory();
  const handleBreadcrumbsClick = event => {
    event.preventDefault();
    history === null || history === void 0 ? void 0 : history.push('/');
  };
  return /*#__PURE__*/_jsxs(Breadcrumbs, {
    testId: TEST_IDS.SEARCH_PAGE_BREADCRUMBS,
    children: [/*#__PURE__*/_jsx(BreadcrumbsItem, {
      href: "/",
      onClick: handleBreadcrumbsClick,
      text: "Marketplace"
    }), /*#__PURE__*/_jsx(BreadcrumbsItem, {
      text: "Search",
      onClick: e => e.preventDefault()
    })]
  });
};
export default SearchBreadcrumbs;